import { ListItemText, styled } from '@mui/material';

export const ListItemTextStyled = styled(ListItemText, {
  shouldForwardProp: (prop) =>
    prop !== 'underline' &&
    prop !== 'textTransform' &&
    prop !== 'color' &&
    prop !== 'cursor',
})(({ theme, underline, textTransform, color, cursor }) => ({
  flex: 'none',
  color: theme.palette.colors[color || 'onPrimaryBackground'],
  textTransform: textTransform || 'uppercase',
  textDecoration: underline && 'underline',
  cursor,
  '& .MuiListItemText-primary': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
}));
